import React from 'react'
import { Image } from "react-bootstrap";
import NumberFormat from 'react-number-format'
import { useTranslation } from '../../hooks/useTranslation';

function CompanyProductSummaryMobile({ getProdName, currencyCode, getTotalPrice, getCurrency, currentProduct, itemCount }) {
    const { t } = useTranslation();

    return (
        <>
            <div className="company-shop-item hidden-desk">
                {currentProduct.images && currentProduct.images.length > 0 ? <Image className="comp-gift-img" alt={getProdName()} src={currentProduct.images[0].fullURL} /> : null}
                <div className="comp-item-description">
                    <span aria-label={getProdName()} className="comp-prod-name" dangerouslySetInnerHTML={{ __html: getProdName() }}></span>
                    <div className="d-flex justify-content-end">
                        <span className="comp-item-price">{currentProduct.productPriceAfterDiscount + getCurrency()}</span>
                    </div>
                </div>
                <div>
                </div>
            </div>
            <div className="d-flex justify-content-between hidden-desk cart-row border-underline">
                <span className="quantity">{t("Quantity")}</span>
                <span>{itemCount}</span>
            </div>
            <div className="d-flex justify-content-between mb-4 mt-2 hidden-desk cart-row border-underline">
                <span>{t("Total")}</span>
                <NumberFormat className="prod-prc" role="application" aria-roledescription={t("Price")}
                    aria-label={getTotalPrice() + (currencyCode)}
                    value={getTotalPrice().toFixed(2)}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={currencyCode.replace("ILS", "₪")}
                />
            </div>
        </>
    )
}

export default CompanyProductSummaryMobile